import {useEffect, RefObject} from 'react';

type Event = MouseEvent | TouchEvent;

const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
    ref: RefObject<T>,
    handler: (event: Event) => void,
    exclude?: Array<HTMLElement>,
    unsubscribe?: boolean
) => {
    useEffect(() => {
        if (!unsubscribe) {
            const listener = (event: Event) => {
                const el = ref?.current;
                if (!el || el.contains((event?.target as Node) || null)) {
                    return;
                }
                if (exclude && Array.isArray(exclude)) {
                    for (const excludeElement of exclude) {
                        if (excludeElement && excludeElement.contains(event?.target as HTMLElement)) {
                            return;

                        }
                    }
                }

                handler(event);
            };

            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);

            return () => {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            };
        }
    }, [ref, handler]); // Reload only if ref or handler changes
};

export default useOnClickOutside